let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hFqnt")).then(() => parcelRequire('j7fW8'));